import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function homeImageSliderAnimation() {
  
  if ( document.querySelectorAll(".js-mouse-scroll-slider").length ) {
    
    if (window.matchMedia('(min-width: 768px)').matches) {

      $('.js-mouse-scroll-slider').each(function(){
        let trigger = $(this);
        let element = $(this).find('.js-mouse-scroll-slider__track');
        let movement = -50;

        let mouseScrollSliderTL = gsap.timeline({ });
        let animation = gsap.to(element, {duration: 1, xPercent: movement, ease: "none", } );

        ScrollTrigger.create({
          animation: animation,
          trigger: trigger,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
          markers: false,
        });
      });

    }
  }
  
}



export default homeImageSliderAnimation;



